export default "__VITE_ASSET__78UqnC1c__"